import { Date } from "./Date";
import { TimeZoneOffset } from "./TimeZoneOffset";
export var DateTime;
(function (DateTime) {
    function isHours(v) {
        return (v[0] >= "0" && v[0] <= "1" && v[1] >= "0" && v[1] <= "9") || (v[0] == "2" && v[1] >= "0" && v[1] <= "3");
    }
    function isMinutes(v) {
        return v[0] >= "0" && v[0] <= "5" && v[1] >= "0" && v[1] <= "9";
    }
    function isSeconds(v) {
        return (v[0] >= "0" && v[0] <= "5" && v[1] >= "0" && v[1] <= "9") || v == "60" || v == "61";
    }
    function is(value) {
        // 2019-04-01T01
        // 2019-04-01T01Z
        // 2019-04-01T01+01:00
        // 2019-04-01T01:11
        // 2019-04-01T01:11Z
        // 2019-04-01T01:11+01:00
        // 2019-04-01T01:11:29
        // 2019-04-01T01:11:29Z
        // 2019-04-01T01:11:29+01:00
        // 2019-04-01T01:11:29.000
        // 2019-04-01T01:11:29.000Z
        // 2019-04-01T01:11:29.000+01:00
        // 01234567890123456789012345678
        // 0         1         2
        return (typeof value == "string" &&
            value.length >= 13 &&
            value.length <= 29 &&
            Date.is(value.substring(0, 10)) &&
            value[10] == "T" &&
            isHours(value.substring(11, 13)) &&
            (value.length == 13 ||
                TimeZoneOffset.is(value.substring(13)) ||
                (value[13] == ":" &&
                    value.length >= 16 &&
                    isMinutes(value.substring(14, 16)) &&
                    (value.length == 16 ||
                        TimeZoneOffset.is(value.substring(16)) ||
                        (value[16] == ":" &&
                            value.length >= 19 &&
                            isSeconds(value.substring(17, 19)) &&
                            (value.length == 19 ||
                                TimeZoneOffset.is(value.substring(19)) ||
                                (value[19] == "." &&
                                    value.length >= 23 &&
                                    [...value.substring(20, 23)].every(c => c >= "0" && c <= "9") &&
                                    (value.length == 23 || TimeZoneOffset.is(value.substring(23))))))))));
    }
    DateTime.is = is;
    function parse(value) {
        return new globalThis.Date(DateTime.truncate(value, "milliseconds"));
    }
    DateTime.parse = parse;
    function create(value, resolution = "seconds") {
        if (typeof value == "number") {
            switch (resolution) {
                case "days":
                    value = value * 24;
                // fallthrough...
                case "hours":
                    value = value * 60;
                // fallthrough...
                case "minutes":
                    value = value * 60;
                // fallthrough...
                case "seconds":
                    value = value * 1000;
                // fallthrough...
                case "milliseconds":
            }
            value = new globalThis.Date(value);
        }
        return fixIncorrect(value.toISOString());
    }
    DateTime.create = create;
    function fixIncorrect(value) {
        if (value.length == 22 && value.match(/\.\dZ$/))
            value = value.substring(0, 21) + "00Z";
        else if (value.length == 23 && value.match(/\.\d\dZ$/))
            value = value.substring(0, 22) + "0Z";
        return value;
    }
    DateTime.fixIncorrect = fixIncorrect;
    /**
     * Return local time with offset.
     * Note: During DST-change, this might be wrong.
     */
    function fromLocalDateTime(localDateTime, timeZone) {
        // Cut off any time-zone-information:
        // TODO: Use the information, and just change offset.
        localDateTime = localDateTime.replace(/(Z|([+-].{5}))?$/, "");
        // Create a Date object with the specified time as UTC
        const utcDateTime = new globalThis.Date(`${localDateTime}Z`);
        const localDate = new globalThis.Date(utcDateTime.toLocaleString("sv-SE", { timeZone: timeZone }).replace(" ", "T") + "Z");
        // Calculate the time difference in minutes
        const diffInMinutes = (localDate.getTime() - utcDateTime.getTime()) / 60000;
        // Calculate the timezone's offset in hours and minutes
        const offsetHours = Math.floor(Math.abs(diffInMinutes) / 60)
            .toString()
            .padStart(2, "0");
        const offsetMinutes = (Math.abs(diffInMinutes) % 60).toString().padStart(2, "0");
        // Create the timezone string
        const timeZoneString = `${diffInMinutes >= 0 ? "+" : "-"}${offsetHours}:${offsetMinutes}`;
        // Return the formatted date string with timezone information
        return `${localDateTime}${timeZoneString}`;
    }
    DateTime.fromLocalDateTime = fromLocalDateTime;
    function now() {
        return create(new globalThis.Date());
    }
    DateTime.now = now;
    function localize(value, formatOrLocale, localeOrTimeZone) {
        let result;
        if (typeof formatOrLocale == "object") {
            // formatOrLocale is Format
            // localeOrTimeZone is Locale | undefined
            const localeString = localeOrTimeZone ? localeOrTimeZone : Intl.DateTimeFormat().resolvedOptions().locale;
            result = (is(value) ? parse(value) : value)
                .toLocaleString(localeString, formatOrLocale)
                // For consistency, replace NNBSP with space:
                // Unicode has decided to use `Narrow No-Break Space (NNBSP)` (U+202F) instead of space in some cases.
                // It breaks tests, when running in different environments.
                // https://icu.unicode.org/download/72#:~:text=In%20many%20formatting%20patterns%2C%20ASCII%20spaces%20are%20replaced%20with%20Unicode%20spaces%20(e.g.%2C%20a%20%22thin%20space%22)
                // This can be removed, with a breaking change and updated tests, when all systems use updated versions of ICU.
                .replaceAll(" ", " ");
        }
        else {
            // formatOrLocale is Locale | undefined
            // localeOrTimeZone is timeZone | undefined
            const precision = is(value) ? DateTime.precision(value) : "milliseconds";
            result = localize(value, {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: precision == "minutes" || precision == "seconds" || precision == "milliseconds" ? "2-digit" : undefined,
                second: precision == "seconds" || precision == "milliseconds" ? "2-digit" : undefined,
                timeZone: localeOrTimeZone,
            }, formatOrLocale);
        }
        return result;
    }
    DateTime.localize = localize;
    /** @deprecated Use timeZoneOffset() */
    function timeZone(value) {
        return timeZoneOffset(value);
    }
    DateTime.timeZone = timeZone;
    function timeZoneOffset(value) {
        const result = value[value.length - 1] == "Z" ? "Z" : value.substring(value.length - 6);
        return TimeZoneOffset.is(result) ? result : "";
    }
    DateTime.timeZoneOffset = timeZoneOffset;
    function timeZoneShort(value) {
        return parse(value).getTimezoneOffset();
    }
    DateTime.timeZoneShort = timeZoneShort;
    function precision(value) {
        const zone = timeZoneOffset(value);
        const time = value.substring(0, value.length - zone.length).split("T", 2)[1];
        let result;
        switch (time.length) {
            case 2:
                result = "hours";
                break;
            case 5:
                result = "minutes";
                break;
            case 8:
                result = "seconds";
                break;
            default:
            case 12:
                result = "milliseconds";
                break;
        }
        return result;
    }
    DateTime.precision = precision;
    function truncate(value, precision) {
        const zone = timeZoneOffset(value);
        // eslint-disable-next-line prefer-const
        let [date, time] = value.split("T", 2);
        time = time.substring(0, time.length - zone.length);
        switch (time.length) {
            case 2:
                time += ":00:00.000";
                break;
            case 5:
                time += ":00.000";
                break;
            case 8:
                time += ".000";
                break;
        }
        let result;
        switch (precision) {
            case "hours":
                result = time.substring(0, 2);
                break;
            case "minutes":
                result = time.substring(0, 5);
                break;
            case "seconds":
                result = time.substring(0, 8);
                break;
            case "milliseconds":
                result = time.substring(0, 12);
                break;
        }
        return date + "T" + result + zone;
    }
    DateTime.truncate = truncate;
    function epoch(value, resolution = "seconds") {
        let result = (typeof value == "string" ? parse(value) : value).getTime();
        switch (resolution) {
            case "days":
                result = Math.round(result / 24);
            // fallthrough...
            case "hours":
                result = Math.round(result / 60);
            // fallthrough...
            case "minutes":
                result = Math.round(result / 60);
            // fallthrough...
            case "seconds":
                result = Math.round(result / 1000);
            // fallthrough...
            case "milliseconds":
        }
        return result;
    }
    DateTime.epoch = epoch;
    function next(time, span = 1) {
        let result;
        if (typeof span == "number")
            result = nextSecond(time, span);
        else {
            result = time;
            if (span.years)
                result = nextYear(result, span.years);
            if (span.months)
                result = nextMonth(result, span.months);
            if (span.days)
                result = nextDay(result, span.days);
            if (span.hours)
                result = nextHour(result, span.hours);
            if (span.minutes)
                result = nextMinute(result, span.minutes);
            if (span.seconds)
                result = nextSecond(result, span.seconds);
            if (span.milliseconds)
                result = nextMillisecond(result, span.milliseconds);
        }
        return result;
    }
    DateTime.next = next;
    function previous(time, span = 1) {
        let result;
        if (typeof span == "number")
            result = previousSecond(time, span);
        else {
            result = time;
            if (span.years)
                result = previousYear(result, span.years);
            if (span.months)
                result = previousMonth(result, span.months);
            if (span.days)
                result = previousDay(result, span.days);
            if (span.hours)
                result = previousHour(result, span.hours);
            if (span.minutes)
                result = previousMinute(result, span.minutes);
            if (span.seconds)
                result = previousSecond(result, span.seconds);
            if (span.milliseconds)
                result = previousMillisecond(result, span.milliseconds);
        }
        return result;
    }
    DateTime.previous = previous;
    function nextMillisecond(time, milliseconds = 1) {
        const result = parse(time);
        result.setMilliseconds(result.getMilliseconds() + milliseconds);
        return DateTime.create(result);
    }
    DateTime.nextMillisecond = nextMillisecond;
    function previousMillisecond(time, milliseconds = 1) {
        return nextMillisecond(time, -milliseconds);
    }
    DateTime.previousMillisecond = previousMillisecond;
    function nextSecond(time, seconds = 1) {
        const result = parse(time);
        result.setSeconds(result.getSeconds() + seconds);
        return DateTime.create(result);
    }
    DateTime.nextSecond = nextSecond;
    function previousSecond(time, seconds = 1) {
        return nextSecond(time, -seconds);
    }
    DateTime.previousSecond = previousSecond;
    function nextMinute(time, minutes = 1) {
        const result = parse(time);
        result.setMinutes(result.getMinutes() + minutes);
        return DateTime.create(result);
    }
    DateTime.nextMinute = nextMinute;
    function previousMinute(time, minutes = 1) {
        return nextMinute(time, -minutes);
    }
    DateTime.previousMinute = previousMinute;
    function nextHour(time, hours = 1) {
        const result = parse(time);
        result.setHours(result.getHours() + hours);
        return DateTime.create(result);
    }
    DateTime.nextHour = nextHour;
    function previousHour(time, hours = 1) {
        return nextHour(time, -hours);
    }
    DateTime.previousHour = previousHour;
    function nextDay(time, days = 1) {
        const result = parse(time);
        const offset = result.getTimezoneOffset();
        result.setDate(result.getDate() + days);
        result.setMinutes(result.getMinutes() + offset - result.getTimezoneOffset()); // handle changing potential daylight saving time
        return DateTime.create(result);
    }
    DateTime.nextDay = nextDay;
    function previousDay(time, days = 1) {
        return nextDay(time, -days);
    }
    DateTime.previousDay = previousDay;
    function nextMonth(time, months = 1) {
        const result = parse(time);
        const offset = result.getTimezoneOffset();
        result.setMonth(result.getMonth() + months);
        result.setMinutes(result.getMinutes() + offset - result.getTimezoneOffset()); // handle changing potential daylight saving time
        return DateTime.create(result);
    }
    DateTime.nextMonth = nextMonth;
    function previousMonth(time, months = 1) {
        return nextMonth(time, -months);
    }
    DateTime.previousMonth = previousMonth;
    function nextYear(time, years = 1) {
        const result = parse(time);
        result.setFullYear(result.getFullYear() + years);
        return DateTime.create(result);
    }
    DateTime.nextYear = nextYear;
    function previousYear(time, years = 1) {
        return nextYear(time, -years);
    }
    DateTime.previousYear = previousYear;
    function getDate(time) {
        return time.substring(0, 10);
    }
    DateTime.getDate = getDate;
    function getTime(time) {
        return time.substring(11);
    }
    DateTime.getTime = getTime;
    function getYear(time) {
        return Number.parseInt(time.substring(0, 4));
    }
    DateTime.getYear = getYear;
    function getMonth(time) {
        return Number.parseInt(time.substring(5, 7));
    }
    DateTime.getMonth = getMonth;
    function getDay(time) {
        return Number.parseInt(time.substring(8, 10));
    }
    DateTime.getDay = getDay;
    function getHour(time) {
        return Number.parseInt(time.substring(11, 13));
    }
    DateTime.getHour = getHour;
    function getMinute(time) {
        return Number.parseInt(time.substring(14, 16));
    }
    DateTime.getMinute = getMinute;
    function getSecond(time) {
        return Number.parseInt(time.substring(17, 19));
    }
    DateTime.getSecond = getSecond;
    function getMillisecond(time) {
        return Number.parseInt(time.substring(20, 23));
    }
    DateTime.getMillisecond = getMillisecond;
    function span(time, relative, greatestUnit = "years") {
        let result;
        if (greatestUnit == "years") {
            result = {
                ...Date.span(time, relative),
                hours: getHour(time) - getHour(relative),
                minutes: getMinute(time) - getMinute(relative),
                seconds: getSecond(time) - getSecond(relative),
                milliseconds: getMillisecond(time) - getMillisecond(relative),
            };
        }
        else {
            let milliseconds = epoch(time, "milliseconds") - epoch(relative, "milliseconds");
            const sign = Math.sign(milliseconds);
            milliseconds = Math.abs(milliseconds);
            result = {};
            switch (greatestUnit) {
                case "hours":
                    result.hours = sign * Math.floor(milliseconds / (3600 * 1000));
                    milliseconds -= sign * result.hours * 3600 * 1000;
                // Fallthrough...
                case "minutes":
                    result.minutes = sign * Math.floor(milliseconds / (60 * 1000));
                    milliseconds -= sign * result.minutes * 60 * 1000;
                // Fallthrough...
                case "seconds":
                    result.seconds = sign * Math.floor(milliseconds / 1000);
                    milliseconds -= sign * result.seconds * 1000;
                // Fallthrough...
                case "milliseconds":
                    result.milliseconds = sign * milliseconds;
            }
        }
        return result;
    }
    DateTime.span = span;
    DateTime.epochStart = "0000-01-01T00:00:00.000Z";
    DateTime.epochEnd = "9999-12-31T23:59:59.999Z";
    function invert(time) {
        return `${Date.invert(getDate(time))}T${(24 - getHour(time)).toFixed(0).padStart(2, "0")}:${(60 - getMinute(time))
            .toFixed(0)
            .padStart(2, "0")}:${(60 - getSecond(time)).toFixed(0).padStart(2, "0")}.${(999 - getMillisecond(time))
            .toFixed(0)
            .padStart(3, "0")}Z`;
    }
    DateTime.invert = invert;
})(DateTime || (DateTime = {}));
/*
2021-01-10T13:37:42.000Z
012345678901234567890123
0         1         2
*/
//# sourceMappingURL=DateTime.js.map